import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../core/common';
import { IGetFilterSampleUsageReport, ISampleRegion } from '../../../../../core/models';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { forEach } from 'lodash';

@Component({
  selector: 'app-sample-request-usage-report',
  templateUrl: './sample-request-usage-report.component.html',
  styleUrls: ['./sample-request-usage-report.component.scss']
})
export class SampleRequestUsageReportComponent implements OnInit {
  filterUsageHeaderForm: FormGroup;
  filterSaveInProcess: boolean;
  usageHeaderGridData: GridDataResult;
  totalUsageGridData: any[] = [];
  usageGridData: any[] = [];
  usageLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  filterValidateMessage: boolean;
  public getSampleRegion: ISampleRegion[] = [];
  isInActiveUsage: boolean;
  selectedRegionDescription: string = '';
  selectedRegionCode: string = '';
  //#region label declaration  

  public usageLblText = {
    stockNumLbl: 'Stock #',
    categoryLbl: 'Category',
    productDescriptionLbl: 'Product Description',
    regionLbl: 'Region',
    createdDateLbl: 'Order Date',    
    costLbl: 'Cost',
    ordersLbl: 'Order',
    usageLbl: 'Usage',
    isActiveLbl:'Active',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Product',
    infoMessageLbl: 'Please Select Start Date and End Date',
    startDateLbl: 'Start Date',
    endDateLbl: 'End Date',
    filterlbl: 'Filter',
    displayInactiveLbl: 'Include Inactive Items',
    sampleProductUsageLbl: 'Sample Product Usage List'
  };
  //#endregion
  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService, private cp: CurrencyPipe
  ) { }

  ngOnInit() {
    this.isInActiveUsage = false;
    this.initializeFormControls();
    this.getAllSampleRegion();
    this.getFilterUsageHeader();    
  }
  
  initializeFormControls() {
    this.filterUsageHeaderForm = this.formBuilder.group({
      startDate: new FormControl(),
      endDate: new FormControl(),
      region: new FormControl(),
    });
    let todaysDate = new Date();
    let priorDate = new Date(new Date().setDate(todaysDate.getDate() - 30));
    this.filterUsageHeaderForm.controls.startDate.setValue(priorDate);
    this.filterUsageHeaderForm.controls.endDate.setValue(todaysDate);    
  }

  public usageGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryName',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public usageGridSettings: GridSettings = {
    state: this.usageGridstate,
    gridData: process(this.usageGridData, this.usageGridstate),
    columnsConfig: [{
      field: 'stockNum',
      title: this.usageLblText.stockNumLbl,
      filterable: true,
      widthForPDF: 50,
      _width: 110,
    },
    {
      field: 'categoryName',
      title: this.usageLblText.categoryLbl,
      filterable: true,
      widthForPDF: 80,
      _width: 130,
    }, {
      field: 'subCategoryDescription',
      title: this.usageLblText.productDescriptionLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 100,
      _width: 250,
    }
      , {
        field: 'totalCost',
        title: this.usageLblText.costLbl,
      filterable: true,
      widthForPDF: 60,
      _width: 110,
    }
      ,
    {
      field: 'totalQuantity',
      title: this.usageLblText.usageLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 40,
      _width: 110,
    }, {
      field: 'totalOrders',
      title: this.usageLblText.ordersLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 50,
      _width: 110,
    },{
      field: 'isActive',
      title: this.usageLblText.isActiveLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 60,
      _width: 100,
      },
      //{
      //  field: 'region',
      //  title: this.usageLblText.regionLbl,
      //  //_width: 200,
      //  filterable: true,
      //  widthForPDF: 40,
      //  _width: 100,
      //}
    ]
  };

  filterInActiveUsageItems(event) {
    if (event.target.checked)
      this.isInActiveUsage = true;
    else
      this.isInActiveUsage = false;
    //this.getFilterReorderItems();
  }
  getAllSampleRegion() {
    this.productSampleFulfillmentService.GetSampleRegions().subscribe(response => {
      this.getSampleRegion.push({ regionCode: "ALL", regionDescription: "All Regions" });
      response.forEach((region: ISampleRegion) => {
        this.getSampleRegion.push({ regionCode: region.regionCode, regionDescription: region.regionDescription });
      }) 
    });
    this.selectedRegionCode = "ALL";
    this.selectedRegionDescription = "All Regions";
  }
  getFilterUsageHeader() {
    this.filterValidateMessage = false;
    this.usageLoading = true;
    if (!this.validateFilterUsageHeaderForm()) {
      this.filterValidateMessage = true;
      return;
    }

    var controls = this.filterUsageHeaderForm.controls;
    const body: IGetFilterSampleUsageReport = {
      startDate: controls.startDate.value,
      endDate: controls.endDate.value,
      region: controls.region.value ? controls.region.value.regionCode : "",
      isActive: this.isInActiveUsage
    }
    this.productSampleFulfillmentService.getAllSampleUsageReport(body).subscribe((response: Array<any>) => {
      if (response) {
        this.totalUsageGridData = response;
        if (this.isInActiveUsage) {
          //const dataList = this.totalUsageGridData.filter(r => r.isActive === false);
          this.usageGridData = response;
        }
        else {
          const dataList = this.totalUsageGridData.filter(r => r.isActive === true);
          this.usageGridData = dataList;
        }          
        this.productSampleFulfillmentService.setUsageHeaderGridData(this.usageGridData);
        this.loadUsageHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Soory an error occured while loading the page.');
    })
    this.usageLoading = false;
  }

  public loadUsageHeaderGridData(): void {
    if (this.usageGridSettings.state)
      this.usageHeaderGridData = process(this.usageGridData, this.usageGridSettings.state);
    else
      this.usageHeaderGridData = process(this.usageGridData, this.usageGridstate);
    this.usageGridSettings.gridData = this.usageHeaderGridData;
  }
  public usageHeaderGridSortChange(sort): void {
    this.usageGridstate.sort = sort;
    this.loadUsageHeaderGridData();
  }

  public usageHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.usageGridstate.skip = skip;
    this.usageGridstate.take;
    this.loadUsageHeaderGridData();
  }

  public usageHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.usageGridstate = state;
    this.usageGridSettings.state = this.usageGridstate;
    this.loadUsageHeaderGridData();
  }


  validateFilterUsageHeaderForm() {
    let isValid = true;
    const controls = this.filterUsageHeaderForm.controls;
    if (controls.startDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    if (controls.endDate.value) {
      //this.finishSampleLbl.isEmptySubCategory = false;
    } else {
      //this.finishSampleLbl.isEmptySubCategory = true;
      isValid = false;
    }
    return isValid;
  }

  generateExcel() {
    this.loadingExcel = true;
    var controls = this.filterUsageHeaderForm.controls;
    var currFilter = this.usageGridSettings.state.filter;
    var filterData = process(this.usageGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.usageGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });    
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [
      this.usageLblText.stockNumLbl,
      this.usageLblText.categoryLbl,
      this.usageLblText.productDescriptionLbl,
      this.usageLblText.costLbl,
      this.usageLblText.usageLbl,
      this.usageLblText.ordersLbl,
      this.usageLblText.isActiveLbl
    ];
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', this.usageLblText.startDateLbl + ": " + toDate]);
    worksheet.addRow(['', '', this.usageLblText.endDateLbl + ": " + fromDate]);
    worksheet.addRow(['', '', this.usageLblText.regionLbl + ": " + controls.region.value ? controls.region.value.regionDescription : "",]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let orderDetailsRow = worksheet.addRow([this.usageLblText.sampleProductUsageLbl]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    dataArray.map(p =>
    ([
      p.stockNum ? p.stockNum : '',
      p.categoryName ? p.categoryName : '',
      p.subCategoryDescription ? p.subCategoryDescription : '',
      p.totalCost ? this.cp.transform(p.totalCost, 'USD', true, '1.2-2') : '',
      p.totalQuantity ? p.totalQuantity : '',
      p.totalOrders ? p.totalOrders : '',
      p.isActive ? (p.isActive == true ? 'Yes ' : 'No') : 'No'
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleRequestUsageReport.xlsx');
    })
    this.loadingExcel = false;
  }

  async generatePDF() {
    this.loadingPDF = true;
    var controls = this.filterUsageHeaderForm.controls;
    var toDate = formatDate(controls.startDate.value, 'MM/dd/yyyy', 'en');
    var fromDate = formatDate(controls.endDate.value, 'MM/dd/yyyy', 'en');
    var currFilter = this.usageGridSettings.state.filter;
    var filterData = process(this.usageGridData, {
      filter: currFilter
    });
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.usageGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });

    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.usageLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: this.usageLblText.startDateLbl + ": " + toDate,
              bold: true,
              margin: [0, 2, 0, 2]
            },
              {
                text: this.usageLblText.endDateLbl + ": " + fromDate,
              bold: true,
              margin: [0, 2, 0, 2]
            }],
            {
              text: this.usageLblText.regionLbl + ": " + controls.region.value ? controls.region.value.regionDescription : "",
              margin: [0, 2, 0, 2]
            }
            ]
        },
        {
          text: this.usageLblText.sampleProductUsageLbl,
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,
            body: [
              [
                this.usageLblText.stockNumLbl,
                this.usageLblText.categoryLbl,
                this.usageLblText.productDescriptionLbl,
                this.usageLblText.costLbl,
                this.usageLblText.usageLbl,
                this.usageLblText.ordersLbl,
                this.usageLblText.isActiveLbl
              ],
              ...filterData.data.map(p =>
              ([
                p.stockNum ? p.stockNum : '',
                p.categoryName ? p.categoryName : '',
                p.subCategoryDescription ? p.subCategoryDescription : '',
                p.totalCost ? this.cp.transform(p.totalCost, 'USD', true, '1.2-2') : '',
                p.totalQuantity ? p.totalQuantity : '',
                p.totalOrders ? p.totalOrders : '',
                p.isActive ? (p.isActive == true ? 'Yes ' : 'No') : 'No'

              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('SampleRequestUsageReport.pdf');
    this.loadingPDF = false;
  }

}
